/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Form } from 'antd';
import { Grid, TextField, Snackbar, Select, InputLabel, MenuItem } from '@material-ui/core';
import { SitesInput } from '../../../components/SitesInput/SitesInput';
import SnackbarContentWrapper from '../../../components/SnackBar';

class siteForm extends React.Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    sites: this.props.sites ? this.props.sites : [],
    role: this.props.role ? this.props.role : '',
    snackOpen: false,
    snackType: 'info',
    snackMessage: 'Action executing...',
  };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  setStateValues = (open, type, message) => {
    this.setState({ snackOpen: open });
    this.setState({ snackType: type });
    this.setState({ snackMessage: message });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ snackOpen: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const variables = {
          ...(this.props.id && { id: this.props.id }),
          name: values.name,
          email: values.email,
          password: values.password,
          role: this.state.role,
        };

        this.props.query_f({ variables }).then(result => {
          this.props.query_access({ variables: { user: result.data.createUser ? result.data.createUser.id : this.props.id, site: this.state.sites } })
            .then(result => {
              this.setStateValues(true, 'success', 'Action executed with success! (Sites)');
            }, error => {
              console.error('Error on sites: ', error);
              this.setStateValues(true, 'error', 'Action executed with error! (Sites)');
            });

          this.props.form.resetFields();
          if (this.props.onCancel) { this.props.onCancel(); }
        }, error => {
          console.error('Error on user: ', error);
          this.setStateValues(true, 'error', 'Action executed with error! (User)');
        });
      } else {
        this.setStateValues(true, 'error', 'Form validation failed! (User)');
      }
    });
  }

  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

  handleChangeRole = (e) => {
    const value = e && e.target ? e.target.value : '';
    this.setState({ role: value });
  };

  sitesChange = (value) => {
    this.setState({ sites: value });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const myForm = this.props;
    const sitesData = { sitesData: this.state.sites };

    return (
      <form id="myForm" onSubmit={this.handleSubmit}>
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackOpen} autoHideDuration={6000} onClose={this.handleClose}>
          <SnackbarContentWrapper onClose={this.handleClose} variant={this.state.snackType} message={this.state.snackMessage} />
        </Snackbar>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            {getFieldDecorator('name', { initialValue: (this.props.name || ''), rules: [{ required: true }] })(
              <TextField
                id="name"
                label="name"
                color="primary"
                fullWidth
                style={{ marginTop: 13 }}
                InputLabelProps={{ shrink: true }}
                placeholder="name"
              />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('email', { initialValue: (this.props.email || ''), rules: [{ required: true }] })(
              <TextField
                id="email"
                label="email"
                color="primary"
                fullWidth
                style={{ marginTop: 13 }}
                InputLabelProps={{ shrink: true }}
                placeholder="email"
              />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('password', { initialValue: (this.props.password || ''), rules: [{ required: false }] })(
              <TextField
                id="password"
                label="password"
                type="password"
                color="primary"
                fullWidth
                style={{ marginTop: 13 }}
                InputLabelProps={{ shrink: true }}
                placeholder="password"
              />,
            )}
          </Grid>
          <Grid item xs={12}>
            <InputLabel style={{ fontSize: 12, marginTop: 15 }}>Role</InputLabel>
            <Select
              fullWidth
              id="role"
              labelId="select-settings-role"
              onChange={this.handleChangeRole}
              value={this.state.role}
            >
              <MenuItem value="CONTENTMANAGER">Content Manager</MenuItem>
              <MenuItem value="EDITOR">Editor</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={12}>
            <SitesInput form={myForm} sitesData={sitesData} onChange={this.sitesChange} />
          </Grid>
        </Grid>
      </form>
    );
  }
}

const sitesForm = Form.create()(siteForm);

export default sitesForm;
